import { formatDateDefault } from 'services/DateFormatters';
import { fetchDataRequest } from 'services/ApiService';
import { ORGID_PATH_PARAM, FEATUREID_PATH_PARAM } from 'constants/api';

export const mapInwardDependenciesToDisplayData = (allFeatures, feature) => {
    return mapDependenciesToDisplayData(allFeatures, feature, true);
};

export const mapOutwardDependenciesToDisplayData = (allFeatures, feature) => {
    return mapDependenciesToDisplayData(allFeatures, feature, false);
};


export const mapDependenciesToDisplayData = (allFeatures, feature, inward) => {
    let dependencyData = new Array();
    if (Array.isArray(feature?.dependencies) && feature?.dependencies?.length > 0) {
        feature?.dependencies?.map((link) => {
            let linkedId = 0;
            if (inward) {
                if (link?.inward !== undefined) {
                    linkedId = link?.inward?.id;
                }
            } else {
                if (link?.outward !== undefined) {
                    linkedId = link?.outward?.id;
                }
            }
            const found = allFeatures?.find((element) => element?.id === linkedId);
            if (found) {
                dependencyData.push(getDisplayData(found));
            }
        });
    }
    return dependencyData;
};

export const getDisplayData = (feature) => {
    return {
        id: feature?.id,
        name: feature?.name ? feature?.name : 'No summary specified',
        description: feature?.description ? feature?.description : 'No description specified',
        succcessIndicators: feature?.succcessIndicators,
        startDate: formatDateDefault(feature?.startDate),
        endDate: formatDateDefault(feature?.endDate),
        priority: feature?.priority,
    };
};


export const getFeatureDisplayData = async (featureId, orgid) => {
    const fetchedData = await fetchDataRequest('featureDisplayData', [ORGID_PATH_PARAM, FEATUREID_PATH_PARAM], [orgid, featureId]) || [];
    return {
        id: fetchedData?.id ? fetchedData?.id : 0,
        name: fetchedData?.name ? fetchedData?.name : 'No name specified',
        description: fetchedData?.description ? fetchedData?.description : 'No description specified',
        type: fetchedData?.type ? fetchedData?.type : 'No type specified',
        priority: fetchedData?.priority ? fetchedData?.priority : 'No priority specified',
        succcessIndicators: fetchedData?.succcessIndicators ? fetchedData?.succcessIndicators : 'No success indicators specified',
        startDate: fetchedData?.startDate ? formatDateDefault(fetchedData?.startDate) : 'No start date specified',
        endDate: fetchedData?.endDate ? formatDateDefault(fetchedData?.endDate) : 'No end date specified',
        initiative: fetchedData?.initiativeName ? fetchedData?.initiativeName : 'No initiative specified', 
    };
};




// WEBPACK FOOTER //
// ./services/featureService.js